import { Box, InputLabel, Select, Tooltip, FormControl, OutlinedInput, Input, Icon } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import React, { FC, ReactNode, useState } from "react";

interface ViewEditSelectProps {
  props: {
    id: string;
    label: string;
    tooltip?: string;
    initialValue?: string | string[]; // Should only be string[] when "multiple" is true
    isEdit: boolean;
    menuProps?: any;
    multiple?: boolean;
    required?: boolean;
    size?: "small" | "medium";
    handleInputChange: (newValue: any, field: string) => void;
    renderValue?: (value: any) => ReactNode
  };
}

const ViewEditSelect: FC<ViewEditSelectProps> = ({ props, children }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleTooltip = (isOpen: boolean) => {
    setTooltipOpen(isOpen);
  };

  const classNames = ["view-edit-box"];
  if (!props.isEdit) classNames.push("read-only");

  return (
    <Box m={1} className={classNames.join(" ")}>
      <Tooltip open={tooltipOpen} title={props.tooltip ?? ""}>
        <FormControl required={props.required} variant={props.isEdit ? "outlined" : "standard"} margin="dense" size={props.size || "small"} fullWidth>
          <InputLabel shrink={props.isEdit || (props.initialValue ? true : false)}>{props.label}</InputLabel>
          <Select
            fullWidth
            IconComponent={props.isEdit ? ArrowDropDownIcon : Icon}
            input={props.isEdit ? <OutlinedInput notched={true} label={props.label} /> : <Input />}
            inputProps={{
              readOnly: !props.isEdit,
            }}
            label={props.label}
            multiple={props.multiple}
            MenuProps={props.menuProps}
            renderValue={props.renderValue}
            value={props.initialValue || ""}
            onMouseEnter={() => {
              handleTooltip(true);
            }}
            onMouseLeave={() => {
              handleTooltip(false);
            }}
            onOpen={() => {
              handleTooltip(false);
            }}
            onChange={(e) => props.handleInputChange(e.target.value, props.id)}
          >
            {children}
          </Select>
        </FormControl>
      </Tooltip>
    </Box>
  );
};

export default ViewEditSelect;
